import { Component } from '@angular/core';

@Component({
  selector: 'app-watermark-pdf-content',
  imports: [],
  templateUrl: './watermark-pdf-content.component.html',
  styleUrl: './watermark-pdf-content.component.css'
})
export class WatermarkPdfContentComponent {

}
